// Slice Select Tool — select and manipulate slices created by the Slice tool.

import { screenToDoc } from "../render/Viewport";
import type { PointerSample, Tool, ToolContext } from "./Tool";
import type { Slice } from "./SliceTool";

export class SliceSelectTool implements Tool {
  readonly id = "slice-select";
  readonly shortcut = "C";

  slices: Slice[] = [];
  selectedSliceId: string | null = null;
  private dragging = false;
  private dragStart: { x: number; y: number } | null = null;

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    if (!ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    // Find slice under cursor (reverse order for top-most)
    for (let i = this.slices.length - 1; i >= 0; i--) {
      const sl = this.slices[i]!;
      if (p.x >= sl.x && p.x <= sl.x + sl.width && p.y >= sl.y && p.y <= sl.y + sl.height) {
        this.selectedSliceId = sl.id;
        this.dragging = true;
        this.dragStart = { x: p.x - sl.x, y: p.y - sl.y };
        ctx.requestRender();
        return;
      }
    }
    this.selectedSliceId = null;
    ctx.requestRender();
  }

  onPointerMove(ctx: ToolContext, s: PointerSample): void {
    if (!this.dragging || !this.dragStart || !this.selectedSliceId) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    for (const sl of this.slices) {
      if (sl.id === this.selectedSliceId) {
        sl.x = Math.round(p.x - this.dragStart.x);
        sl.y = Math.round(p.y - this.dragStart.y);
        break;
      }
    }
    ctx.requestRender();
  }

  onPointerUp(ctx: ToolContext): void {
    this.dragging = false;
    this.dragStart = null;
  }
}
